module.exports = __webpack_public_path__ + "img/COMGATE.9564549d.svg";